import { S, ui } from "../../app/store.js";

const proj = (c) => S.projects.find((p) => p.code === c);

const projectSite = (code) =>
  S.projects.find((p) => p.code === code)?.siteId || code || "";

const siteById = (id) => S.sites.find((x) => x.id === id);

const siteCode = (p) => siteById(p.siteId || p.id)?.code || p.code;

const selectedSite = () => ui.site ?? "ALL";

const inSite = (code) =>
  selectedSite() === "ALL" || projectSite(code) === selectedSite();

const siteName = (code) => siteById(code)?.code || "Head office / unassigned";

export {
  proj,
  projectSite,
  siteById,
  siteCode,
  selectedSite,
  inSite,
  siteName,
};
